import React, { useEffect } from 'react'

import classes from './index.module.scss';
import { Grid } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import ProductRepository from 'client-sdk/src/Repository/product-repository';
import handleError from '../../../../utils/handleError';

const Pictures = (props: any) => {
  const [images, setImages] = React.useState(false);
  const [mainPic, setMainPic] = React.useState(null)
  let { id } = useParams()


  // useEffect(() => {
  //   getImages()
  // }, [props.images])

  useEffect(() => {
    if (props.images.length > 0) {
      setMainPic(props.images[0])
      setTimeout(() => {
        setImages(true)
      }, 2000)
    }
  }, [props.images])

  const getImages = async () => {
    const imagesList: string[] = []
    try {
      props?.images?.forEach(async (prod: any) => {
        if (prod) {
          const image = await ProductRepository.getImagefromVitrin({ payload: { id, fileName: prod } });
          imagesList.push(image.data)
          setImages(imagesList)
        }
      });
    } catch (err) {
      handleError(err)
    }
  }

  const showImages = () => {
    return props.images.map(el => (
      <Grid item lg={3}>
        <img onClick={() => setMainPic(el)} className={classes.pic + ' w-100 ' + (el === mainPic && classes.activePic)} src={`data:image/*;base64,${el}`} alt="main pic" />
      </Grid>
    ))
  }
  return (
    <div className='mx-5'>
      <Grid container spacing={2}>
        <Grid item lg={12}>
          {mainPic ? <img className={classes.mainPic + ' w-100'} src={`data:image/*;base64,${mainPic}`} alt="main pic" /> : <img className={classes.mainPic + ' w-100'} src="/vitrin/images/nophoto.jpg" alt="main pic" />}
        </Grid>
        {images && showImages()}
      </Grid>
    </div>
  )
}

export default Pictures
